<template>
  <div>
    <select class="form-control" v-model="value">
      <option v-if="addEmptySelectItem" :value="EmptyItemValue">{{EmptyItemText}}</option>
      <option v-for="(item, value) in options" :key="value" :value="item">{{value}}</option>
    </select>
  </div>
</template>

<script>/**
 <MyCodeListSelect v-model="selectValue" :options="$u.UCode_CLInvoiceType" v-bind:add-empty-select-item="true"></MyCodeListSelect>
 **/
import Util from "@/util/util"


export default {
  // name: "MyColorPicker",
  props: {
    value: {
      type: String,
      required: true
    },
    // size: {
    //   type: String,
    //   default: "lg"
    // },
    // buttonVariant: {
    //   type: String,
    //   default: "outline-primary"
    // },
    options: {
      type: Object,
      required: true
    },
    addEmptySelectItem:{
      type:Boolean,
      default:false,
    },
    EmptyItemText:{
      type:String,
      default:"",
    },
    EmptyItemValue:{
      type:String,
      default:"",
    }
  },
  data: function () {
    return {
      id: "",
      formData: {
        name: "",
      },
      propsValue:this.value,
      selected: 'radio1',
      optionsDemo: [
        { text: 'Radio 1', value: 'radio1' },
        { text: 'Radio 3', value: 'radio2' },
        { text: 'Radio 3 (disabled)', value: 'radio3', disabled: true },
        { text: 'Radio 4', value: 'radio4' }
      ]
    };
  },
  watch: {
    propsValue(newVal){
      this.$emit('input', newVal);
    },
    value(newVal){
      this.propsValue = newVal
    }
  },
  methods: {
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    disable(){
      this.value=false;
    },
    enable(){
      this.value=true;
    },
    getContrlName(){
      return Util.uuid();
    },
  },
  mounted() {
    //this.loadData()
  },
}
</script>

<style scoped>

</style>
